import Shepherd from 'shepherd.js';

if($('.account.editor').length){
    
    ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
        var data = {
            'page': 'account-editor'
        };
        axios.post("/api/v1/onboarding", data)
        .then((response) =>  {
        }).catch(function (error) {
            console.log('onboarding logged')
        });
    }));
    
    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            classes: 'shepherd-container',
            scrollTo: { behavior: 'smooth', block: 'center' }
        },
        useModalOverlay: true
    });
    
    tour.addStep({
        title: 'Setup your Company Summary',
        text: "You will need a corporate license to publish Challenges on LEO. Our team have been notified of your interest in a license. In the meantime, you need to set up your company summary page before you can start creating a Challenge. The summary page will be publically viewable and any Challenge will be held in draft until a license is purchased.",
        buttons: [
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-1'
    });
    
    tour.addStep({
        title: 'Toggle between views',
        text: "Using these two toggles, you can switch the view mode between a full view of your company summary page and the editor form.",
        attachTo: {
            element: '#editor-header .middle',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    });
    
    tour.addStep({
        title: 'Checking your progress',
        text: "This shows the percentage of your company summary page progress completion. You won't be able to save the details unless it is 100% complete.",
        attachTo: {
            element: '.radial-progress',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-3'
    });
    
    tour.addStep({
        title: 'Editing your account',
        text: "Complete the fields in this section to create your summary page, you can add your Company Name, Strapline and Description. Add your company's logo, colours and primary market sector.",
        attachTo: {
            element: '.editor-section',
            on: $(window).width() < 992 ? 'top' : 'right'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-4'
    });
    
    tour.addStep({
        title: 'Saving',
        text: "Once you've finished editing your summary page, click the 'Create' to button to create your page. You can always make changes later and save them.",
        attachTo: {
            element: '#editor-header .right',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-5'
    });
    
    tour.addStep({
        title: "Once you're finished",
        text: "When you are finished in the editor you can click this button to go back to your dashboard or the previous page. Make sure you've saved the summary page first though!",
        attachTo: {
            element: '#editor-header .left',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-6'
    });
    
    tour.addStep({
        title: "What next?",
        text: "Once you're done creating your company summary page head over to your dashboard and create a Challenge either using the card on the overview page or from the Challenges page.",
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.complete();
                },
                classes: 'btn btn--secondary',
                text: 'Finish'
            }
        ],
        id: 'step-6'
    });    

    $('.replay-onboarding').show();
    $('.replay-onboarding').click(function(){
        tour.start();
    });

    if($('.account.editor').length && !$('.onboarding-account-editor').length){
        tour.start();
    }
}
